import React from 'react';
import {
    MdBusiness,
    MdEmail,
    MdLabel,
    MdLocationOn,
    MdPerson,
    MdPhone,
    MdWarning,
} from 'react-icons/md';
import { useLabels } from '../../contexts/LanguageContext';
import { getActiveUserInfo, UserInfo } from '../../utils/localStore.util';

const AccountInfoCards: React.FC = () => {
    const labels = useLabels();
    const userInfo: UserInfo = getActiveUserInfo();

    const cards = [
        {
            key: 'company',
            label: labels.lbl_company_name,
            value: (userInfo.company as string) || 'N/A',
            icon: MdBusiness,
        },
        {
            key: 'category',
            label: labels.lbl_services_availed,
            value: (userInfo.category?.title as string) || 'N/A',
            icon: MdLabel,
        },
        {
            key: 'address',
            label: labels.lbl_company_address,
            value: (userInfo.address as string) || 'N/A',
            icon: MdLocationOn,
        },
        {
            key: 'name',
            label: labels.lbl_coordinator,
            value: (userInfo.name as string) || 'N/A',
            icon: MdPerson,
        },
        {
            key: 'phone',
            label: labels.lbl_contact_no,
            value: (userInfo.phone as string) || 'N/A',
            icon: MdPhone,
        },
        {
            key: 'marketerContact',
            label: labels.lbl_marketer_contact_info,
            value: (userInfo.marketer_email as string) || (userInfo.marketer_phone as string) || 'N/A',
            icon: MdEmail,
        },
        {
            key: 'emergency_contact',
            label: 'Emergency Number',
            value: (userInfo.emergency_contact as string) || 'N/A',
            icon: MdWarning,
        },
    ];

    return (
        <div className="space-y-4">
            <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wider px-1">
                Account Information
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
                {cards.map((card) => {
                    const Icon = card.icon;
                    return (
                        <div
                            key={card.key}
                            className="bg-white rounded-2xl p-5 border border-brand-100 shadow-sm hover:shadow-md hover:border-brand-100 transition-all duration-200 group"
                        >
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-200">
                                    <Icon size={20} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-xs font-medium text-slate-400 uppercase tracking-wide">
                                        {card.label}
                                    </p>
                                    <p className="text-sm font-semibold text-slate-800 mt-1 break-words">
                                        {card.value}
                                    </p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AccountInfoCards;